<article *ngIf="data">
    <div class="container">
        <div class="row">
            <div class="col-md-5 offset-md-1">
                <header>
                    <div class="headline">
                        <app-spot-headline *ngIf="data.headlineText as headlineText" [index]="data.spotIndex">
                            {{ headlineText }}
                        </app-spot-headline>
                    </div>
                    <p class="display-5" *ngIf="data.paragraph as paragraph">
                        {{ paragraph }}
                    </p>
                    <div class="link-wrapper" *ngIf="data.link as link">
                        <app-arrow-link [link]="link" [arrowFirst]="true">
                            {{ link.name }}
                        </app-arrow-link>
                    </div>
                </header>
            </div>
            <div class="col-md-4 offset-md-1">
                <section>
                    <form [formGroup]="form" appHandleInvalidOnSubmit (ngSubmit)="onSubmit()">
                        <div class="name-inputs">
                            <div class="name-input">
                                <app-input
                                    [control]="form.controls['firstName']"
                                    [label]="'newsletter.labels.firstName' | translateSafe"
                                    [placeholder]="'newsletter.placeholders.firstName' | translateSafe"
                                    autocomplete="given-name"
                                    marginBottom="small"
                                ></app-input>
                            </div>
                            <div class="name-input">
                                <app-input
                                    [control]="form.controls['lastName']"
                                    [label]="'newsletter.labels.lastName' | translateSafe"
                                    [placeholder]="'newsletter.placeholders.lastName' | translateSafe"
                                    autocomplete="family-name"
                                    marginBottom="small"
                                ></app-input>
                            </div>
                        </div>
                        <app-input-email
                            [control]="form.controls['email']"
                            [label]="'newsletter.labels.email' | translateSafe"
                            [placeholder]="'newsletter.placeholders.email' | translateSafe"
                            marginBottom="small"
                        >
                        </app-input-email>
                        <app-checkbox [control]="form.controls['isOptIn']" marginBottom="small">
                            <span
                                *ngIf="data.disclaimer"
                                class="kk-rte"
                                appInterceptLinks
                                [innerHTML]="data.disclaimer | safe: 'html'"
                            ></span>
                        </app-checkbox>
                        <button [disabled]="submitting" class="kk-btn">
                            <ng-container *ngIf="!submitting">
                                {{ 'newsletter.buttonSignUp' | translateSafe }}
                            </ng-container>
                            <app-loading-dots *ngIf="submitting"></app-loading-dots>
                        </button>
                    </form>
                </section>
            </div>
        </div>
    </div>
</article>
